import { useEffect, useState } from "react";

/**
 * Debounce a rapidly-changing value (e.g. a search box) so downstream work — a
 * server-filtered KPI query — runs on the settled value, not every keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
